import { Card, CardTypeMap } from "@mui/material";
import { BaseProps } from "@mui/material/OverridableComponent";
import { styled } from "@mui/material/styles";
import * as React from "react";

interface IProps {
    id?: string;
    paperColor?: MprcColorsExtended | [MprcColors, MprcColorVariant] | "inherit";
    borderRadius?: "none" | "xs" | "sm" | "md" | "lg";
}

type Props = IProps & Omit<BaseProps<CardTypeMap>, "color" | "borderRadius">;

const StyledCard = styled
    (
        Card,
        { shouldForwardProp: (propName: string) => propName != "paperColor" && propName != "borderRadius" }
    )<Props>(
        ({ theme, paperColor, borderRadius }) => (
            {
                backgroundColor: Array.isArray(paperColor)
                    ? theme.palette[paperColor[0]!][paperColor[1]!]
                    : paperColor == "white"
                        ? theme.palette.common.white
                        : paperColor == "black"
                            ? theme.palette.common.black
                            : paperColor == "inherit"
                                ? "inherit"
                                : paperColor == "transparent"
                                    ? "transparent"
                                    : theme.palette[paperColor!].main,
                borderRadius: borderRadius == "xs"
                    ? "2px"
                    : borderRadius == "sm"
                        ? "4px"
                        : borderRadius == "md"
                            ? "8px"
                            : borderRadius == "lg"
                                ? "16px"
                                : 0
            }
        ));

export const MprcCard: React.FC<Props> = (props) => {
    const {
        children,
        paperColor = "white",
        borderRadius = "md",
        ...rest
    } = props;

    return (
        <StyledCard className="MprcCard" paperColor={paperColor} borderRadius={borderRadius} {...rest}>
            {children}
        </StyledCard>
    );
};
